module.exports = __webpack_public_path__ + "static/media/ramen.70ff5827.svg";